import { ReportCardComponent } from 'components/landing-page';
import RecentReportsComponent from 'components/landing-page/recent-reports-component';

const LandingPageReportContainer = () => {
  return (
    <>
      <div className='landing-page-report-container'>
        <ReportCardComponent />
        <RecentReportsComponent />
      </div>
    </>
  );
};

export default LandingPageReportContainer;
